import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import userReducer from "./reducers/userReducer";
import reducer from "./reducers/Reducer";
import favoritesReducer from "./reducers/favoritesSlice";
import themeValueReducer from "./reducers/themeValueReducer";
import NotificationReducer from "./reducers/notificationReducer";

import { injectStore } from "../api/axiosInstance";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "referer", "favorites", "themeValue"],
};

const rootReducer = combineReducers({
  user: userReducer,
  referer: reducer,
  favorites: favoritesReducer,
  themeValue: themeValueReducer,
  notification: NotificationReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const persister = persistStore(store);

// 🔥 inject AFTER store exists
injectStore(store);

export default store;
